import { registerSW } from 'virtual:pwa-register';
/**
 * Registers the service worker.
 * Returns a function that, when called, triggers skipWaiting + reload.
 */
export function setupPWA(
  onNeedRefresh?: () => void,
  onOfflineReady?: () => void
): () => Promise<void> {
  let checkTimer: number | null = null;
  const applyUpdate = registerSW({
    immediate: true, // start checking right away
    onNeedRefresh() {
      onNeedRefresh?.();
    },
    onOfflineReady() {
      onOfflineReady?.();
    },
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;

      // Force periodic update checks while app is open (installed users keep apps open for long sessions).
      void registration.update();
      checkTimer = window.setInterval(() => {
        void registration.update();
      }, 5 * 60 * 1000);
    },
    onRegisterError(err: unknown) {
      console.error('SW registration error:', err);
    },
  });

  const wrappedApplyUpdate = async () => {
    if (checkTimer != null) {
      window.clearInterval(checkTimer);
      checkTimer = null;
    }
    await applyUpdate();
  };

  return wrappedApplyUpdate;
}
